import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToRem } from '@vfit/shared/themes';

// MOBILE TABLET
export const CountrySectionInNoDesktop = styled.section`
  border: 1.5px solid ${colors.$bebebe};
  padding: ${pxToRem(24)};

  &:first-of-type {
    border-radius: ${pxToRem(12, 12, 0, 0)};
    border-bottom: none;
  }

  &:last-of-type {
    border-radius: ${pxToRem(0, 0, 12, 12)};
    border-top: none;
  }
`;

export const CountryTitleNoDesktop = styled.h2`
  font-family: ${fonts.vodafone};
  font-weight: 800;
  font-size: ${pxToRem(24)};
  margin: ${pxToRem(0, 0, 16)};
  line-height: ${pxToRem(32)};
  text-align: center;
`;

export const DataNoDesktopRow = styled.div`
  align-items: center;
  color: ${colors.$262626};
  display: flex;
  font-family: ${fonts.regular};
  font-weight: 700;
  justify-content: space-between;
  margin: ${pxToRem(0, 0, 16)} !important;

  @media (min-width: ${breakpoints.tablet}) {
    width: unset;
    height: ${pxToRem(24)};
  }
`;

export const DataTypeNoDesktop = styled.h3`
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(24)};
  margin: 0;
  text-transform: uppercase;
  font-weight: 400;
  width: ${pxToRem(127)};

  @media (min-width: ${breakpoints.tablet}) {
    width: unset;
  }
`;

export const DataValueNoDesktop = styled.span`
  font-size: ${pxToRem(18)};
`;

export const RateSummaryTableNoDesktop = styled.div`
  display: flex;
  flex-direction: column;
`;

// DESKTOP
export const TableContainerInDesktop = styled.div`
  border: 1.5px solid ${colors.$bebebe};
  border-radius: ${pxToRem(16)};
  overflow: hidden;
`;

export const TableHeaderDesktop = styled.header`
  align-items: center;
  background-color: ${colors.$f2f2f2};
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  font-family: ${fonts.regular};
  font-weight: 400;
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(25)};
`;

export const CellDesktop = styled.div`
  align-items: center;
  display: flex;
  min-height: ${pxToRem(80)};
  justify-content: center;
  width: ${pxToRem(117)};
  padding: ${pxToRem(28, 16)};

  :first-child {
    font-family: ${fonts.vodafone};
    font-size: ${pxToRem(22)};
    font-weight: 800;
    line-height: ${pxToRem(32)};
    margin: 0;
    min-width: ${pxToRem(150)};
    width: ${pxToRem(127)};
  }
`;

export const TopLeftCorner = styled(CellDesktop)`
  &&& {
    text-transform: uppercase;
    font-family: ${fonts.vodafone};
    font-weight: 700;
    font-size: ${pxToRem(18)};
    line-height: ${pxToRem(24)};
    justify-content: flex-start;
  }
`;

export const TableBodyDesktop = styled.main``;

export const TableBodyRow = styled.div`
  align-items: center;
  border-bottom: 1.5px solid ${colors.$bebebe};
  display: flex;
  font-family: ${fonts.vodafone};
  font-weight: 400;
  font-size: ${pxToRem(22)};
  line-height: ${pxToRem(32)};

  :first-child {
    min-width: ${pxToRem(150)};
  }
`;
